export const priceStrategyTasksTableStructure = {
    massActions: [
    ],
    headers: {
        centralId: {
            text: "ID",
            key: "centralId",
            type: "number",
            sortable: true,
            style: "cursor:pointer;width:5%",
        },
        name: {
            text: "Nazwa",
            key: "name",
            type: "text",
            sortable: true,
            style: "cursor:pointer;width:35%",
        }, // available types: number, string, date,datetime,array,boolean,actions,button
        creator: {
            text: "Autor",
            key: "creator",
            type: "text",
            sortable: true,
            style: "cursor:pointer;width:10%",
        },
        type: {
            text: "Typ strategii",
            key: "type",
            type: "text",
            sortable: true,
            style: "cursor:pointer;width:10%",
        },
        lastUpdate: {
            text: "Ost. aktualizacja",
            key: "lastUpdate",
            type: "datetime",
            sortable: true,
            style: "cursor:pointer;width:10%",
            isEpochMillis: true,
        },
        active: {
            text: "Aktywny",
            key: "active",
            type: "boolean",
            sortable: true,
            style: "cursor:pointer;width:10%",
        },
        actions: {
            text: "Akcje",
            key: "actions",
            type: "actions",
            style: "cursor:pointer;width:20%",
            visible: true,
            actions: [
                {
                    text: "Edytuj",
                    icon: "edit",
                    action: "edit",
                    class: "btn btn-info table-actions-button edit-button",
                    enabled: true,
                },
                {
                    text: "Usuń",
                    icon: "trash-alt",
                    action: "delete",
                    class: "btn btn-danger table-actions-button edit-button",
                    enabled: true,
                },
            ],
        },
    },
    data: [],
};
